export default __webpack_public_path__ + "static/media/_DSC0518.f1f1b6bd.jpg";